import PropTypes from 'prop-types';
import { Card } from "../ui/card";

const StatCard = ({
    title,
    icon,
    count = null,
    color,
    path,
    navigate
}) => {
    return (
        <Card
            className={`
                ${color} 
                text-white 
                p-3 md:p-4 
                relative 
                min-h-[100px] md:min-h-[130px] 
                cursor-pointer 
                hover:opacity-75
                transition-all
                duration-200
            `}
            onClick={() => navigate(path)}
        >
            <div className="flex justify-between items-start">
                <div className="scale-75 md:scale-100 transform-gpu">
                    {icon}
                </div>
                <div className="text-lg md:text-2xl font-normal">
                    {count !== null ? count : ''}
                </div>
            </div>
            <div className="
                absolute 
                bottom-3 md:bottom-4 
                left-3 md:left-4 
                font-thin 
                text-base md:text-xl
                break-words 
                max-w-[calc(100%-24px)]
            ">
                {title}
            </div>
        </Card>
    );
};

StatCard.propTypes = {
    title: PropTypes.string.isRequired,
    icon: PropTypes.element.isRequired,
    count: PropTypes.number,
    color: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    navigate: PropTypes.func.isRequired,
};

export default StatCard;